import classNames from "classnames";
import { memo, type FC } from "react";
import { CommitmentIcon } from "@/shared/icons";
import { NOTE_DIRECTIONS, type Note } from "@/services/api/entities/note";
import styles from "./styles.module.scss";

type Props = {
  direction: Note["direction"];
  disabled?: boolean;
};

export const NoteDirection: FC<Props> = memo(({ direction, disabled }) => {
  return (
    <CommitmentIcon
      className={classNames(styles.root, {
        [styles.incoming]: direction === NOTE_DIRECTIONS.INCOMING,
        [styles.disabled]: disabled,
      })}
    />
  );
});
